import { render, staticRenderFns } from "./sidepanel.html?vue&type=template&id=8634a6f4&scoped=true&"
import script from "./sidepanel.js?vue&type=script&lang=js&"
export * from "./sidepanel.js?vue&type=script&lang=js&"
import style0 from "./sidepanel.scss?vue&type=style&index=0&id=8634a6f4&prod&scoped=true&lang=scss&"
import style1 from "./index.vue?vue&type=style&index=1&id=8634a6f4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8634a6f4",
  null
  
)

export default component.exports